module.exports = __webpack_public_path__ + "img/catering_menu_4.784c4ac9.jpg";